import request from './axios'

export default {
  // 获取所有资源数据
  getResources() {
    return request.get('/api/resources')
  },
  
  // 创建临时下载链接
  createTempDownloadLink(filePath) {
    return request.post('/api/download/create-link', { filePath })
  },
  
  // 验证下载完成
  verifyDownload(token) {
    return request.post('/api/download/verify-download', { token })
  },
  
  // 获取直接下载链接
  getDirectDownloadUrl(filePath) {
    return `${request.defaults.baseURL || ''}/api/download/file/${encodeURIComponent(filePath)}`
  }
}